import * as yup from 'yup';

export const UpdateDepartamentFormValidation = yup.object().shape({
    description: yup.string().required('Nome do departamento é obrigatório'),
    idFaculty: yup.string().required('Unidade orgânica é obrigatória'),
    id: yup.string().required('ID é obrigatório'),
    status: yup.bool().required('Status é obrigatório'),
    province: yup.string().required('Campo é obrigatório'),
});